import { render } from "./NumberUnit.vue?vue&type=template&id=6f8f3aa2&scoped=true&ts=true"
import script from "./NumberUnit.vue?vue&type=script&lang=ts"
export * from "./NumberUnit.vue?vue&type=script&lang=ts"

import "./NumberUnit.vue?vue&type=style&index=0&id=6f8f3aa2&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f8f3aa2"]])

export default __exports__